import fetch from '@giro/shared-utils/fetch.util';

export default async function postApiPaymentLinksIdDispatchService(
  id: string,
  body: any
) {
  return fetch(`payment-links/${id}/dispatch`, {
    method: 'POST',
    ms: 'PDV',
    auth: true,
    body: JSON.stringify(body),
  });
}
